import { styled } from '@mui/system';
import { black, blue, darkBlue, greyBorder, lightGrey, red, white } from '@cpg-its/ads.constants.colors';
// eslint-disable-next-line max-len
const StyledPickerComponent = (type) => styled(type)({
    display: 'flex',
    '& div.MuiInputBase-root': {
        backgroundColor: white,
        border: `1px solid ${greyBorder}`,
        borderRadius: '3px',
        height: '2.5rem',
        '&:hover': {
            border: `1px solid ${blue}`,
        },
    },
    '& div.MuiOutlinedInput-root': {
        padding: 0,
    },
    '& div.Mui-focused': {
        border: `1px solid ${darkBlue}`,
    },
    '& div.Mui-disabled': {
        backgroundColor: lightGrey,
        border: `1px solid ${black}`,
        color: black,
        '& svg.MuiSvgIcon-root': {
            color: black,
        },
    },
    '& p.MuiFormHelperText-root': {
        color: red,
    },
    '& input': {
        borderRadius: '3px',
        border: '1px solid transparent',
        fontSize: '0.875rem',
        height: 'calc(100% - 4px)',
        margin: '1px',
        padding: '0 5px',
        width: '100%',
        '&:focus': {
            border: `1px solid ${darkBlue}`,
        },
    },
    '& fieldset': {
        border: 0,
    },
    '& button.MuiIconButton-root': {
        position: 'absolute',
        right: '1rem',
        padding: 0,
    },
    '& div.MuiInputAdornment-root': {
        marginLeft: 0,
    },
    '& svg.MuiSvgIcon-root': {
        color: blue,
    },
});
export default StyledPickerComponent;
//# sourceMappingURL=styled-picker.js.map